/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Notifications_Empty_Title1Inputs */

const en_coinvestments_notifications_empty_title1 = /** @type {(inputs: Coinvestments_Notifications_Empty_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notifications yet`)
};

/**
* | output |
* | --- |
* | "No notifications yet" |
*
* @param {Coinvestments_Notifications_Empty_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_notifications_empty_title1 = /** @type {((inputs?: Coinvestments_Notifications_Empty_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Notifications_Empty_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_notifications_empty_title1(inputs)
});
export { coinvestments_notifications_empty_title1 as "coInvestments_notifications_empty_title" }